// extracted by mini-css-extract-plugin
export var label = "_3z-1";
export var reminder = "_3z-0";